import { Box, Button, Container } from "@mui/material";
import { OverrideFooterButtonWrapper } from "./OverrideFooterButtonStyled";

const OverrideFooterButtons = ({ leftButton, rightButton, onSubmitButton }) => {
    return (
        <OverrideFooterButtonWrapper>
            <Container maxWidth="xl">
                <Box className="d-flex">
                    <Box className="rightButton">
                        <Button variant="contained" >{leftButton}</Button>
                    </Box>
                    <Box className="leftButtons">
                        <div className="leftBtnTwo">
                            <Button variant="contained"  onClick={onSubmitButton}>{rightButton}</Button>
                        </div>
                    </Box>
                </Box>
            </Container>
        </OverrideFooterButtonWrapper>
    );
};

export default OverrideFooterButtons;